import gql from 'graphql-tag';

export const GET_USER_DATA_SUMMARY = gql`
  query userDataSummary {
    getUserDataSummary {
      ratedResources {
        ratedId
        ratedType
        rating
        updatedAt
        createdAt
      }
    }
  }
`;

export default GET_USER_DATA_SUMMARY;
